export default __webpack_public_path__ + "static/media/soundofmusic.cf0d4d28.png";